
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDivider, MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';

import { FormViewModel } from 'src/app/shared/models/FormModels';

@Component({
    selector: 'app-form-admin-card',
    imports: [RouterModule, MatCardModule, MatDividerModule],
    templateUrl: './form-admin-card.component.html',
    styleUrl: './form-admin-card.component.css'
})
export class FormAdminCardComponent {
  @Input() Form: FormViewModel;

}


